<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col-1-1 bold">
    </div>
    <div class="col-2 bold">
      Huidige periode
    </div>
    <div class="col-3 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <form [formGroup]="averageNumberEmployeesNetherlandsFg">
    <div class="row">
      <div class="col-1-1">
        <p style="padding: 6px">Gemiddeld aantal werknemers werkzaam binnen Nederland</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150"
                                          align="right"
                                          [showAllDecimals]="true"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150"
                                          align="right"
                                          [showAllDecimals]="true"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="averageNumberEmployeesAbroadFg">
    <div class="row">
      <div class="col-1-1">
        <p style="padding: 6px">Gemiddeld aantal werknemers werkzaam buiten buitenland</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150"
                                          align="right"
                                          [showAllDecimals]="true"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150"
                                          align="right"
                                          [showAllDecimals]="true"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="averageNumberEmployeesFg">
    <div class="row">
      <div class="col-1-1">
        <p style="padding: 6px"><b>Totaal van gemiddeld aantal werknemers over de periode</b></p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          [calculate]="this.getTotalen()"
                                          [showAllDecimals]="true"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          [calculate]="this.getTotalen()"
                                          [showAllDecimals]="true"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="averageNumberEmployeesDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over gemiddeld aantal werknemers over de periode</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.averageNumberEmployeesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(1)">
          {{ this.averageNumberEmployeesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.averageNumberEmployeesDisclosureFg"
                                                               [title]="'Informatieverschaffing over gemiddeld aantal werknemers over de periode'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

